import { createStore, applyMiddleware, compose } from 'redux'
import reducers from './../reducers'

// Setup react router
import history from './history';
import { connectRouter, routerMiddleware } from 'connected-react-router'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const routingMiddleware = routerMiddleware(history)

const enhancer = composeEnhancers(
    applyMiddleware(routingMiddleware)
)

const store = createStore(
    connectRouter(history)(reducers),
    {},
    enhancer
)

export default store;


// WEBPACK FOOTER //
// ./src/stores/index.js